import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Folder } from 'src/app/digigov/models/folder.model';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { FolderService } from './folder.service';

/*const folders: Folder[] = [
  {id:1, folderName:"ABC", description:"this is 1 fie"},
  {id:2, folderName:"ABC2", description:"this is 2 fie"},
  {id:3, folderName:"ABC3", description:"this is 3 fie"},
];*/

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.scss'],
})
export class FolderComponent implements OnInit {
  expForm: FormGroup = new FormGroup({
    folderName: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9 ]*$'),
    ]),
    folderDesc: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9 ]*$'),
    ]),
  });
  buttonDisable: boolean = false;
  content: any;
  output: any;
  folder: Folder = {
    folderName: null,
    folderDesc: null,
    prntFolderName: '',
    folderId: -1,
    prntFolderId: -1,
  };
  display: any;
  columnConfig = [
    {
      name: 'folderName',
      displayName: this.translate.instant('Create_folder.Name'),
    },
    {
      name: 'folderDesc',
      displayName: this.translate.instant('Create_folder.Description'),
    },
  ];
  showListbox = false;
  showSpinner = true;
  constructor(
    @Optional() public dialogRef: MatDialogRef<FolderComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private service: FolderService,
    private http: HttpClient,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.showListbox = false;

    this.fetchData();
  }

  fetchData(): void {
    let params = new HttpParams();
    params = params.append('folderId', '0');
    params = params.append('fromFolderflag', '0');
    this.http
      .get('/case-mgmnt/user-folders', { params: params })
      .subscribe((res) => {
        this.showSpinner = false;
        this.showListbox = true;
        const restemp: any = res;
        this.content = restemp.data;
      });
  }

  getData(data): void {
    this.output = data;
    this.expForm = new FormGroup({
      folderName: new FormControl(this.output.folderName),
      folderDesc: new FormControl(this.output.folderDesc),
    });
  }
  onSubmit(): void {
    if (!this.expForm.valid) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: 'Please enter name and description!',
      });
    } else {
      this.folder.folderName = this.expForm.value['folderName'];
      this.folder.folderDesc = this.expForm.value['folderDesc'];
      this.service.addFolder(this.folder).subscribe(() => {
        this.expForm.reset();
        this.fetchData();
      });
    }
  }
  edit(): void {
    if (!this.output || this.output.length === 0) {
      this.buttonDisable = false;
      this.dialog.open(SelectCaseDialogComponent, {
        data: 'Please select atleast one folder',
      });
    } else {
      this.buttonDisable = false;
      this.folder.folderId = this.output.folderId;
      this.folder.folderName = this.expForm.value['folderName'];
      this.folder.folderDesc = this.expForm.value['folderDesc'];
      this.service.editFolder(this.folder).subscribe(() => {
        this.expForm.controls['folderName'].setValue(null);
        this.expForm.controls['folderDesc'].setValue(null);
        this.output = null;
        this.fetchData();
      });
    }
  }
  delete(): void {
    if (!this.output || this.output.length === 0) {
      this.buttonDisable = false;
      this.dialog.open(SelectCaseDialogComponent, {
        data: 'Please select atleast one folder',
      });
    } else {
      this.buttonDisable = false;
      this.service.deleteFolder([this.output]).subscribe(() => {
        this.expForm.controls['folderName'].setValue(null);
        this.expForm.controls['folderDesc'].setValue(null);
        this.output = null;
        this.fetchData();
      });
    }
  }
  reset(): void {
    this.output = null;
    this.expForm.reset();
    this.fetchData();
  }
  getErrorMessage(controlName: string, label: string): string {
    const control = this.expForm.get(controlName);
    let errorLabel = this.translate.instant(label);
    if (control.hasError('required')) {
      return 'Please enter ' + errorLabel;
    }
    if (control.hasError('pattern')) {
      return (
        errorLabel + ' should contain only alphanumeric characters and spaces'
      );
    }
    return '';
  }
}
